<template>
  <div class="row">
    <div v-if="!userEntered" class="col-4 offset-2 profile-view" v-bind:class="[publicProfile ? 'current-profile' : 'other-profile']">
      <router-link v-bind:to="publicProfileURL">
        <h4 class="profile-title">Public Profile</h4>
      </router-link>
    </div>
    <div v-else class="col-4">
    </div>
    <div class="col-4 profile-view" v-bind:class="[publicProfile ? 'other-profile' : 'current-profile']">
      <router-link v-bind:to="privateProfileURL">
        <h4 class="profile-title">Owner's View</h4>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    publicProfile: Boolean,
    state: String,
    uniqueId: String,
    userEntered: Boolean
  },
  computed: {
    publicProfileURL () {
      return '/propertysearch/' + this.uniqueId + '/' + this.state + '/info'
    },
    privateProfileURL () {
      return '/property/' + this.uniqueId
    }
  }
}
</script>

<style scoped>
.profile-view {
  border-style: solid;
  border-width: thin;
  margin-bottom: 1rem;
  text-align: center;
}

.profile-title {
  color: var(--dark-color) !important;
  font-weight: bold;
}

.current-profile {
  background-color: var(--secondary-background-color);
}

.other-profile {
  background-color: #D3D3D3; /*#B0C4DE;*/
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/HomeProfileTabs.vue